import React from 'react';
export default function QboValidationDetails({data}){if(!data?.validationPreview)return null;return <details className="finance-preview-evidence"><summary>Accounting reconciliation checks</summary><pre>{JSON.stringify(data.validation,null,2)}</pre></details>;}
